module.exports = __webpack_public_path__ + "static/img/logo-tb.a5b6a9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-tb.png
// module id = VzYB
// module chunks = 1